module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "id": "ae"
    }
  }, [_c('div', {
    staticClass: "gPageBorder"
  }, [_c('el-form', {
    ref: "form",
    staticClass: "gForm",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-position": "right",
      "label-width": "12.5%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_appName'),
      "prop": "appName"
    }
  }, [_c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon(1)),
      expression: "isShowCommon(1)"
    }],
    staticClass: "aeMg contentColor"
  }, [_vm._v(_vm._s((_vm.config.data) ? _vm.config.data.appName : ''))]), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    staticClass: "aeMg",
    model: {
      value: (_vm.form.appName),
      callback: function($$v) {
        _vm.$set(_vm.form, "appName", $$v)
      },
      expression: "form.appName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('psp_app_version'),
      "prop": "appVersion"
    }
  }, [_c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon(1)),
      expression: "isShowCommon(1)"
    }],
    staticClass: "aeMg contentColor"
  }, [_vm._v(_vm._s((_vm.config.data) ? _vm.config.data.appVersion : ''))]), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    staticClass: "aeMg",
    model: {
      value: (_vm.form.appVersion),
      callback: function($$v) {
        _vm.$set(_vm.form, "appVersion", $$v)
      },
      expression: "form.appVersion"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    attrs: {
      "label": _vm.$t('app_selectApp'),
      "prop": "pspAppUrl"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo aeMg",
    attrs: {
      "data": _vm.uData,
      "drag": "",
      "name": "fileUpload",
      "file-list": _vm.fileList,
      "on-success": _vm.fileUploadSuccess,
      "limit": 1,
      "before-upload": _vm.fileBeforeUpload,
      "action": _vm.fileUploadUrl,
      "on-remove": _vm.handleRemove_1
    }
  }, [_c('span', [(_vm.upinfo_1) ? _c('i', {
    class: _vm.ulinfo.icons[0]
  }) : _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "display": "flex",
      "flex-direction": "column"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload",
    style: (_vm.tipColor_1)
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "140px",
      "margin": "0 auto"
    },
    attrs: {
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_reupload')))])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.upinfo_1),
      expression: "upinfo_1"
    }],
    staticClass: "el-upload__text"
  }, [_vm._v(_vm._s(_vm.$t('app_ulNormalSt')))])])])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    attrs: {
      "label": _vm.$t('app_certificate_1_psp'),
      "prop": "cer1Url"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo aeMg",
    attrs: {
      "data": _vm.uData,
      "drag": "",
      "name": "fileUpload",
      "file-list": _vm.fileLists,
      "on-success": _vm.fileUploadSuccesss,
      "limit": 1,
      "before-upload": _vm.fileBeforeUpload,
      "action": _vm.fileUploadUrl,
      "on-remove": _vm.handleRemove_2
    }
  }, [_c('span', [(_vm.upinfo_2) ? _c('i', {
    class: _vm.ulinfo.icons[0]
  }) : _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "display": "flex",
      "flex-direction": "column"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload",
    style: (_vm.tipColor_2)
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "140px",
      "margin": "0 auto"
    },
    attrs: {
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_reupload')))])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.upinfo_2),
      expression: "upinfo_2"
    }],
    staticClass: "el-upload__text"
  }, [_vm._v(_vm._s(_vm.$t('app_ulNormalSt')))])])])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCommon()),
      expression: "isShowCommon()"
    }],
    attrs: {
      "label": _vm.$t('app_certificate_2_psp'),
      "prop": "cer2Url"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo aeMg",
    attrs: {
      "data": _vm.uData,
      "drag": "",
      "name": "fileUpload",
      "file-list": _vm.fileListss,
      "on-success": _vm.fileUploadSuccessss,
      "limit": 1,
      "before-upload": _vm.fileBeforeUpload,
      "action": _vm.fileUploadUrl,
      "on-remove": _vm.handleRemove_3
    }
  }, [_c('span', [(_vm.upinfo_3) ? _c('i', {
    class: _vm.ulinfo.icons[0]
  }) : _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "display": "flex",
      "flex-direction": "column"
    }
  }, [_c('i', {
    staticClass: "el-icon-upload",
    style: (_vm.tipColor_3)
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "140px",
      "margin": "0 auto"
    },
    attrs: {
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_reupload')))])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.upinfo_3),
      expression: "upinfo_3"
    }],
    staticClass: "el-upload__text"
  }, [_vm._v(_vm._s(_vm.$t('app_ulNormalSt')))])])])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "calc(100% + 20px)",
      "background": "#EAEEFA",
      "height": "1px",
      "margin-left": "-10px"
    }
  }), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "background": "none"
    }
  }, [_c('el-button', {
    staticClass: "aeMg",
    attrs: {
      "type": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    staticClass: "aeMg",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.uploadApp('form')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_save')))])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c8f7b90"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/updatePspEdit.vue
// module id = 1001
// module chunks = 0